import React from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal.js';
import loading_gif from '../Images/loading.gif';
import './Organization.css';

class OrganizationSetup extends React.Component {
	constructor(props) {
		super(props);
		// State management:
		if (this.props.location.state) { // Allow stateful linking
			this.state = this.props.location.state;
		}
		else {
			this.state = {
				error: null,
				isLoaded: false,
				siteList: [],
                colTypes: ['Author', 'Date', 'Publication/Event', 'Title', 'Type'],
                userOrgList: [],
				sortCol: 'createdDate',
				sortDir: 'desc',
				page: 0,
				totalPages: 0,
				deleteModalVisible: false,
				siteToDelete: false,
				newModalVisible: false,
				createNewSite: false,
				editModalVisible: false,
				siteToEdit: false,
				editOrgUrl: '',
				editSiteName: '',
				editSiteCols: ['Author', 'Title', 'Publication/Event', 'Date', 'Type'], // defaults
				newOrgCols: ['Author', 'Title', 'Publication/Event', 'Date', 'Type'], // defaults
				newSiteName: '',
				newOrgUrl: '',
				newOrgSel: '',
				ModalMessage: '',
				filterString: '',
				filterArr:  {
                    'site.name': '',
                    'site.id': '',
                    'createdDate': '',
                    'cols.columnName': '',
                    'organization.name': '',
                    'site.url': ''
                }
			};
		}

		// Function bindings:
		this.fetchData = this.fetchData.bind(this);
		this.fetchInitialData = this.fetchInitialData.bind(this);
		this.prevPage = this.prevPage.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.deleteSite = this.deleteSite.bind(this);
		this.handleDeleteModalShow = this.handleDeleteModalShow.bind(this);
		this.handleDeleteModalHide = this.handleDeleteModalHide.bind(this);
		this.filterChange = this.filterChange.bind(this);
		this.sortChange = this.sortChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleNewModalHide = this.handleNewModalHide.bind(this);
		this.handleNewModalShow = this.handleNewModalShow.bind(this);
		this.createSite = this.createSite.bind(this);
		this.handleNewOrgColsOptionChange = this.handleNewOrgColsOptionChange.bind(this);
		this.handleEditOrgColsOptionChange = this.handleEditOrgColsOptionChange.bind(this);
		this.handleEditModalShow = this.handleEditModalShow.bind(this);
		this.handleEditModalHide = this.handleEditModalHide.bind(this);
		this.editSite = this.editSite.bind(this);
	}
	
	// Change our array when the user (un)checks a box in the new site modal
	handleNewOrgColsOptionChange(changeEvent) {
		let selectedCols = this.state.newOrgCols;
		const changedBox = changeEvent.currentTarget.id;
		
		// Case 1: This is a column that can't be unchecked and the user thinks he's clever
		if (['Author', 'Title', 'Publication/Event', 'Date', 'Type'].includes(changedBox)) {
			return; // User isn't as clever as he thinks.
		}
		else if (selectedCols.includes(changedBox)) { // Case 2: unchecking an optional column
			selectedCols = selectedCols.filter(col => col !== changedBox);
		}
		else { // Case 3: checking an optional column
			selectedCols.push(changedBox);
		}
		
		this.setState({
			newOrgCols: selectedCols
		});
	}
	
	// Change our array when the user (un)checks a box in the edit site modal
	handleEditOrgColsOptionChange(changeEvent) {
		let selectedCols = this.state.editSiteCols;
		const changedBox = changeEvent.currentTarget.id;
		
		// Case 1: This is a column that can't be unchecked and the user thinks he's clever
		if (['Author', 'Title', 'Publication/Event', 'Date', 'Type'].includes(changedBox)) {
			return; // User isn't as clever as he thinks.
		}
		else if (selectedCols.includes(changedBox)) { // Case 2: unchecking an optional column
			selectedCols = selectedCols.filter(col => col !== changedBox);
		}
		else { // Case 3: checking an optional column
			selectedCols.push(changedBox);
		}
		
		this.setState({
			editSiteCols: selectedCols
		});
	}
	
	handleChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
	}

	// Get publications for new sorts and filters
	fetchData() {
        const fetchURL = '/webpub-services/siteAPI/getAllSitesByPage?page=' 
			+ this.state.page + '&sort=' + this.state.sortCol + ',' + this.state.sortDir 
			+ '&size=10' + this.state.filterString;
	    this.setState({
			page: 0,
			totalPages: 0,
			siteList: []
		}, () => {
			fetch(fetchURL)
			.then(res => res.json())
			.then(
				(result) => {
					if (result.content && result.content.length && result.content[0].id) { // Results look like we expect
						// If there's something we need to do to these, it could happen here.
						// It might be safer to do it in render(), though.
						let content = [];
                        content = result.content;

						this.setState({
							siteList: content,
							totalPages: result.totalPages,
							isLoaded: true,
							error: false
						});
					}
					else if (result.numberOfElements === 0) { // Results empty, but real
						this.setState({
							siteList: result.content,
							totalPages: result.totalPages,
							isLoaded: true,
							error: false
						});
					}
					else { // Something went wrong. Give up.
						this.setState({
							error: {message: 'Organization or Site results malformed. (OS144)'}
						});
					}
				},

				(error) => {
					this.setState({
						isLoaded: false,
						error: error
					});
				}
			);
		});
	}

	// Get first page of publications and all types for initial page load
	fetchInitialData() {
		if (this.props.orgList && this.props.orgList.length) { // Make sure our props exist
			const fetchURL = '/webpub-services/siteAPI/getAllSitesByPage?page=' 
				+ this.state.page + '&sort=' + this.state.sortCol + ',' + this.state.sortDir 
				+ '&size=10' + this.state.filterString;
			fetch(fetchURL)
				.then(res => res.json())
				.then((data) => { // Everything is resolved at this point. Process it.
					// Process Orgs, Sites, and Cols
					const siteResult = data;

					if (siteResult.content && siteResult.content.length && siteResult.content[0].id) { // Results look like we expect
						// If there's something we need to do to these, it could happen here.
						// It might be safer to do it in render(), though.

						let tOrg = [];
						siteResult.content.map( (oid) => {
							if (oid.organizationId) {
								let oItem = this.props.orgList.filter(thing => thing.id === oid.organizationId)[0];
								
								tOrg.push(oItem);
							}
							return true;
						});

						let uniqOrgs = [...new Set(tOrg)];

						this.setState({
							siteList: siteResult.content,
							totalPages: siteResult.totalPages,
							userOrgList: uniqOrgs,
							isLoaded: true,
							error: false
						});
					}
					else if (siteResult.numberOfElements === 0) { // Results empty, but real
						this.setState({
							siteList: siteResult.content,
							totalPages: siteResult.totalPages,
							isLoaded: true,
							error: false
						});
					}
					else { // Something went wrong. Give up.
						this.setState({
							error: {message: 'Organization, site, or column results malformed. (OS215)'}
						});
						return;
					}
				}
			);
		}
	}

	// Get the previous page's results, preserving the current sort
	prevPage = () => {
        const fetchURL = '/webpub-services/siteAPI/getAllSitesByPage?page=' + 
			this.state.page + '&sort=' + this.state.sortCol + ',' + this.state.sortDir 
			+ '&size=10' + this.state.filterString;
		if (this.state.page >= 1) {
			this.setState((prevState, props) => ({
				page: prevState.page - 1
			}), () => {
				fetch(fetchURL)
				.then(res => res.json())
				.then(
					(result) => {
						if (result.content && result.content.length && result.content.id) { // Results look like we expect
							// If there's something we need to do to these, it could happen here.
							// It might be safer to do it in render(), though.
							let content = [];
                            content = result.content;

							this.setState({
								sitesList: content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else if (result.numberOfElements === 0) { // Results empty, but real
							this.setState({
								siteList: result.content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else { // Something went wrong. Give up.
							this.setState({
								error: {message: 'Previous page results malformed. (OS265)'}
							});
						}
					},

					(error) => {
						this.setState({
							isLoaded: false,
							error: error
						});
					}
				);
			});
		}
	};

	// Get the next page's results, preserving the current sort
	nextPage = () => {
        if (this.state.page < (this.state.totalPages - 1)) {
			this.setState((prevState, props) => ({
				page: prevState.page + 1
			}), () => {
				fetch('/webpub-services/siteAPI/getAllSitesByPage?page=' 
					+ this.state.page + '&sort=' + this.state.sortCol + ',' + this.state.sortDir 
					+ '&size=10' + this.state.filterString)
				.then(res => res.json())
				.then(
					(result) => {
						if (result.content && result.content.length && result.content.id) { // Results look like we expect
							// If there's something we need to do to these, it could happen here.
							// It might be safer to do it in render(), though.
							let content = [];
                            content = result.content;

							this.setState({
								siteList: content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else if (result.numberOfElements === 0) { // Results empty, but real
							this.setState({
								siteList: result.content,
								totalPages: result.totalPages,
								isLoaded: true,
								error: false
							});
						}
						else { // Something went wrong. Give up.
							this.setState({
								error: {message: 'Next page results malformed. (OS314)'}
							});
						}
					},

					(error) => {
						this.setState({
							isLoaded: false,
							error: error
						});
					}
				);
			});
		}
	};

	// Creates a new delete modal for the selected Site
	handleNewModalShow() {
		this.setState({
			newModalVisible: true,
			createNewSite: true
		});
	}

	// Destroys the existing delete modal
	handleNewModalHide() {
		this.setState({
			newModalVisible: false,
			createNewSite: false,
			newOrgCols: ['Author', 'Title', 'Publication/Event', 'Date', 'Type'], // Back to the defaults
			newOrgSel: '', // Back to the default
			newSiteName: '', // Back to the default
			newOrgUrl: '', // Back to the default
			isLoaded: false,
			ModalMessage: ''
		}, () => {
			this.fetchData();
		});
	}

	// Creates a new delete modal for the selected Site
	handleDeleteModalShow(siteToDelete) {
		if (siteToDelete && siteToDelete.id) { // Sanity check
			this.setState({
				deleteModalVisible: true,
				siteToDelete: siteToDelete
			});
		}
		else {
			console.log('Delete modal called without acceptable ID (OS359)');
		}
	}

	// Destroys the existing delete modal
	handleDeleteModalHide() {
		this.setState({
			deleteModalVisible: false,
			siteToDelete: false,
			isLoaded: false,
			ModalMessage: ''
		}, () => {
			this.fetchData();
		});
	}
	
	// Creates a new edit modal for the selected site
	handleEditModalShow(siteToEdit) {
		let editSiteCols = this.state.editSiteCols;
		
		siteToEdit.columns.forEach((col) => { // Check boxes as necessary
			switch (col.columnName) {
				case 'attendees':
					editSiteCols.push('Attendees');
					break;
				case 'publishedDate':
					editSiteCols.push('Date');
					break;
				case 'status':
					editSiteCols.push('Status');
					break;
				default:
					// Skip!
			}
		});
		
		this.setState({
			editModalVisible: true,
			createNewSite: false,
			siteToEdit: siteToEdit,
			editOrgUrl: siteToEdit.url,
			editSiteName: siteToEdit.name,
			editSiteCols: editSiteCols
		});
	}
	
	// Destroys the existing edit modal
	handleEditModalHide() {
		this.setState({
			editModalVisible: false,
			siteToEdit: false,
			editOrgUrl: '', // defaults
			editSiteName: '', // defaults
			editSiteCols: ['Author', 'Title', 'Publication/Event', 'Date', 'Type'], // defaults
			isLoaded: false,
			ModalMessage: ''
		}, () => {
			this.fetchData();
		});
	}

	// Create new site
	createSite() {
		if (this.state.createNewSite === false) { // Extra sanity check.
			this.handleNewModalHide();
		}
		
		let newSiteToCreate = {
			organizationId: this.state.newOrgSel,
			name: this.state.newSiteName,
			url: this.state.newOrgUrl,
			createdDate: new Date(),
			createdUser: this.props.userData.id,
			modifiedDate: new Date(),
			modifiedUser: this.props.userData.id
		};
		
		if (!newSiteToCreate.organizationId) {
			this.setState({
				ModalMessage: 'Please select an Organization.'
			});
			return;
		}
		if (!newSiteToCreate.name || newSiteToCreate.name.length < 5) {
			this.setState({
				ModalMessage: 'Please enter an acceptable Page Name.'
			});
			return;
		}
		if (!newSiteToCreate.url || newSiteToCreate.url.length < 5) {
			this.setState({
				ModalMessage: 'Please enter an acceptable Page URL.'
			});
			return;
		}
		
		fetch(
			'/webpub-services/siteAPI/createSite',
			{
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(newSiteToCreate)
			}
		)
			.then(res => res.json())
			.then(
				(result) => {
					// TODO: deal with return values, I guess?
					if (result.id) {
						let sitePromises = this.state.newOrgCols.map((colName) => {
							let nameToSend = '';
							
							switch (colName) {
								case 'Author':
									nameToSend = 'author';
									break;
								case 'Title':
									nameToSend = 'title';
									break; 
								case 'Publication/Event':
									nameToSend = 'publicationEvent';
									break; 
								case 'Type':
									nameToSend = 'publicationTypeId';
									break;
								case 'Attendees':
									nameToSend = 'attendees';
									break;
								case 'Date':
									nameToSend = 'publishedDate';
									break;
								case 'Status':
									nameToSend = 'status';
									break;
								default:
									return null; // Something screwy happened. Best to just skip this one
							}
							
							let siteFetchPromise = fetch(
								'/webpub-services/siteColumnAPI/createSiteColumn',
								{
									method: 'POST',
									headers: {
										Accept: 'application/json',
										'Content-Type': 'application/json'
									},
									body: JSON.stringify({ siteId: result.id, columnName: nameToSend })
								}
							)
							.then(res => res.json());
							
							return siteFetchPromise;
						});
					
						// Create authorSites, publicationSites
						Promise.all([sitePromises])
							.then(
								result => {
									// Everything is resolved at this point. Great!
									this.handleNewModalHide();
								}
							);
					}
				},

				(error) => {
					// TODO: deal with return values, I guess?
				}
			);
		}

	// Delete the selected site (DANGER! DANGER, WILL ROBINSON)
	deleteSite() {
		const siteToDelete = this.state.siteToDelete;
		if (!(siteToDelete && siteToDelete.id)) { // Extra sanity check.
			this.handleDeleteModalHide();
		}
		
		// Make sure this user has admin privileges for this org.
		const relevantPerms = this.props.userData.permissions
			.filter((org) => (org.accessLevel >= 2 && org.organizationId === siteToDelete.organizationId));

		// Looks good. Let's roll.
		if (relevantPerms.length) {
			fetch(
				'/webpub-services/siteAPI/deleteSiteById/' + siteToDelete.id,
				{
					method: 'DELETE'
				}
			)
			.then(
				(result) => {
					this.handleDeleteModalHide();
				},

				(error) => {
					// TODO: deal with return values, I guess?
					console.log('Error encountered deleting site. (OS566)');
				}
			);
		}
	}

	// Make the API calls to actually edit the site you have in the edit modal
	editSite() {
		if (!this.state.siteToEdit || !this.state.editModalVisible) { // Sanity check
			return;
		}
		
		/*
			Prep work
		*/
		// This is what we're sending. Easy peasy
		let siteToEdit = {
			id: this.state.siteToEdit.id,
			organizationId: this.state.siteToEdit.organizationId,
			name: this.state.editSiteName,
			url: this.state.editOrgUrl,
			createdDate: this.state.siteToEdit.createdDate,
			createdUser: this.state.siteToEdit.createdUser,
			modifiedDate: new Date(),
			modifiedUser: this.props.userData.id
		};
		
		if (!siteToEdit.organizationId) {
			this.setState({
				ModalMessage: 'Please select an Organization.'
			});
			return;
		}
		if (!siteToEdit.name || siteToEdit.name.length < 5) {
			this.setState({
				ModalMessage: 'Please enter an acceptable Page Name.'
			});
			return;
		}
		if (!siteToEdit.url || siteToEdit.url.length < 5) {
			this.setState({
				ModalMessage: 'Please enter an acceptable Page URL.'
			});
			return;
		}
		
		// Here's where it gets more complex: figuring out columns
		let columnsToAdd = []; // An array of columnName strings
		let columnsToDelete = []; // An array of id integers
		
		// Do the research up-front
		const attendeesCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'attendees');
		const hasAttendeesNow = this.state.editSiteCols.includes('Attendees');
		const dateCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'publishedDate');
		const hasDateNow = this.state.editSiteCols.includes('Date');
		const statusCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'status');
		const hasStatusNow = this.state.editSiteCols.includes('Status');
		const authorCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'author');
		const titleCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'title');
		const publicationEventCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'publicationEvent');
		const publicationTypeIdCol = this.state.siteToEdit.columns.filter((col) => col.columnName === 'publicationTypeId');
		
		// Attendees
		if (attendeesCol.length) { // this was here before
			if (!hasAttendeesNow) { // And it no longer is
				columnsToDelete.push(attendeesCol[0].id);
			}
		}
		else if (hasAttendeesNow) { // Wasn't there, but is now. Add it!
			columnsToAdd.push('attendees');
		}
		
		// Date
		if (dateCol.length) { // this was here before
			if (!hasDateNow) { // And it no longer is
				columnsToDelete.push(dateCol[0].id);
			}
		}
		else if (hasDateNow) { // Wasn't there, but is now. Add it!
			columnsToAdd.push('publishedDate');
		}
		
		// Status
		if (statusCol.length) { // this was here before
			if (!hasStatusNow) { // And it no longer is
				columnsToDelete.push(statusCol[0].id);
			}
		}
		else if (hasStatusNow) { // Wasn't there, but is now. Add it!
			columnsToAdd.push('status');
		}
		
		// Default enforcement
		if (!authorCol.length) {
			columnsToAdd.push('author');
		}
		if (!titleCol.length) {
			columnsToAdd.push('title');
		}
		if (!publicationEventCol.length) {
			columnsToAdd.push('publicationEvent');
		}
		if (!publicationTypeIdCol.length) {
			columnsToAdd.push('publicationTypeId');
		}
		
		/*
			Request handling
		*/
		// Make update request
		let updateRequest = fetch(
			'/webpub-services/siteAPI/updateSite',
			{
				method: 'PUT',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(siteToEdit)
			}
		);
		
		// Make column delete requests
		let deleteRequests = columnsToDelete.map((delColId) => {
			return fetch(
				'/webpub-services/siteColumnAPI/deleteSiteColumnById/' + delColId,
				{ method: 'DELETE' }
			);
		});
		
		// Make column addition requests
		let addRequests = columnsToAdd.map((addColName) => {
			return fetch(
				'/webpub-services/siteColumnAPI/createSiteColumn',
				{
					method: 'POST',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ columnName: addColName, siteId: siteToEdit.id})
				}
			);
		});
		
		// One big, happy array
		let requestArr = [updateRequest, deleteRequests, addRequests];
		
		// Deliver on those requests
		Promise.all(requestArr)
		.then(
			result => {
				// Everything is resolved at this point. Great!
				this.handleEditModalHide();
			}
		);
	}

    // Alters the filter string due to user input, then fetches data with the new string
    filterChange(event) {
        const target = event.target;
        var currentFilter = this.state.filterArr;
        var newString = '';

        // Do some sanitizing
        var filterVal = target.value.replace(/[^a-z0-9 .,_-]/gim,"");

        if (target.name === 'createdDate' && filterVal !== '') {
            filterVal = parseInt(filterVal); // Strip out any non-integer characters
            if (!isNaN(filterVal) && filterVal > 0 && filterVal < 9999) {
                filterVal = '' + filterVal; // Get back to a string for the next step
                filterVal.padStart(4, '0');
            }
            else {
                filterVal = currentFilter['createdDate'];
            }
        }

        currentFilter[target.name] = filterVal;

        // Build URL filter string
        Object.keys(currentFilter).map(function(objectKey, index) {
            if (currentFilter[objectKey] !== null && currentFilter[objectKey] !== '') {
                newString += '&' + objectKey + '=' + currentFilter[objectKey];
            }

            return true;
        });

        this.setState({
            filterArr: currentFilter,
            filterString: newString
        }, () => {
            this.fetchData();
        });
    }

    // Alters the sort variables due to user input, then fetches data with the new sorting parameters
    sortChange(event) {
        const target = event.currentTarget;
        const targetName = target.attributes.name.value;

        if (targetName === this.state.sortCol) {
            const newDir = this.state.sortDir === 'asc' ? 'desc' : 'asc';

            this.setState({ sortDir: newDir }, () => { this.fetchData(); });
        }
        else {
            this.setState({
                sortDir: 'asc',
                sortCol: targetName
            }, () => { this.fetchData(); });
        }
    }

	// Initial page load
	componentDidMount() {
		this.fetchInitialData();
	}

	render() {
		// Sanity checking
		if (this.state.error) {
			return <div className='error-text'>
				Error: {
					this.state.error.message
					? this.state.error.message
					: 'An unknown error has occurred (OS498)'
				}
			</div>;
		}
		else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}

		// User can approve/delete items from these orgs:
		const adminOrgs = this.props.userData.permissions.map((org) => {
			if (org.accessLevel >= 2) { // 0 is no access, 1 is read/submit, 2 is admin, 3 is a super-admin
				return org.organizationId;
			}
			else {
				return null;
			}
		}).filter(item => item !== null);
		
		if (!adminOrgs.includes(parseInt(this.props.activeOrg))) { // TRESSPASSER!
			return (
				<div>
					<h2>Organization Setup</h2>
					<div className='error-text'>
						Error: You do not have permission to access Organization Setup for this organization.
					</div>
				</div>
			);
		}

		// Build table contents
		const content = this.state.siteList.map((site) => {
			const org = this.props.orgList.filter(org => org.id === site.organizationId)[0];

			// Format Column names
			let colsUnorderedArr = [];
            for (let i = 0, len = site.columns.length; i < len; i++) {
				let colNameToPrint = '';
				
				switch (site.columns[i].columnName) {
					case 'author':
						colNameToPrint = 'Author';
						break;
					case 'title':
						colNameToPrint = 'Title';
						break; 
					case 'publicationEvent':
						colNameToPrint = 'Publication/Event';
						break; 
					case 'publicationTypeId':
						colNameToPrint = 'Type';
						break;
					case 'attendees':
						colNameToPrint = 'Attendees';
						break;
					case 'publishedDate':
						colNameToPrint = 'Date';
						break;
					case 'status':
						colNameToPrint = 'Status';
						break;
					default:
						// Something screwy happened. Best to just skip this one
				}
												
                colsUnorderedArr.push(colNameToPrint);
            }
			
			// Sort columns
			let colsOrderedArr = ['Author', 'Title', 'Publication/Event', 'Type', 'Date']
				.filter((str) => colsUnorderedArr.includes(str));
			
			// Format column outputs
			const colsSiteList = colsOrderedArr.map((col, idx) => {
				let interpolateStr = idx < colsOrderedArr.length-1 ? ', ' : ''; // Commas where appropriate
				return <span key={'cols-' + col + '-site-' +site.id} >{col + interpolateStr}</span>;
			});

            const siteDate = new Date(site.createdDate.replace(' ', 'T'));

			let displayDate = (siteDate.getMonth()+1) + '/' + siteDate.getDate() + '/' + siteDate.getFullYear();

			// Enable/disable trash can depending on user
			const deleteIcon = adminOrgs.includes(site.organizationId)
			? (
				<span
					className='icon-trash ui-icon tooltip clickable'
					onClick={() => this.handleDeleteModalShow(site)}
				>
					<span className='tooltiptext-bottom'>Delete</span>
				</span>
			)
			: null;

			const editIcon = adminOrgs.includes(site.organizationId)
			? (
				<span
					className='icon-pencil ui-icon tooltip clickable'
					onClick={() => this.handleEditModalShow(site)}
				>
					<span className='tooltiptext-bottom'>Edit</span>
				</span>
			)
			: null;

            return (
				<tr key={'siterow-' + site.id} >
					<td style={{ textAlign: 'left' }} >{org.name}</td>
					<td style={{ textAlign: 'left' }} >{site.name}</td>
                    <td style={{ textAlign: 'left' }} >
						<a 
							href={site.url}
							target='_blank'
							rel='noopener noreferrer'
						>
							{site.url}
						</a>
					</td>
					<td>{site.id}</td>
                    <td style={{ textAlign: 'left', textTransform: 'capitalize'}} >{colsSiteList}</td>
                    <td>{displayDate}</td>
					<td style={{ textAlign: 'left' }} >
						{editIcon}
						{deleteIcon}
					</td>
				</tr>
			);
		});

		const newOrgCols = this.state.colTypes.map((addCol) => {
			return (
				<div key={'newOrgCol-' + addCol} style={{ whiteSpace: 'nowrap', display: 'inline'}} >
					<input 
						type='checkbox'
						name='newOrgCols'
						id={addCol}
						checked={this.state.newOrgCols.includes(addCol)}
						onChange={this.handleNewOrgColsOptionChange}
						disabled={
							['Author', 'Title', 'Publication/Event', 'Date', 'Type'].includes(addCol) // Required columns
						}
					/>
					<label htmlFor={addCol} style={{ paddingLeft: 5, wordWrap: 'anywhere' }}>{addCol}</label>
					<br />
				</div>
			);
		});

		const newOrgSelOptions = this.props.orgList.filter(org => adminOrgs.includes(org.id)).map((addOrg) => {
			return <option value={addOrg.id} key={'status-' + addOrg.id} >{addOrg.name}</option>;
		});

		const addNewSite = (
		<table className='orgs-table'>
			<thead>
				<tr className='orgs-head-row'>
					<th className='orgs-header'>Organization</th>
					<th className='orgs-header'>Page Name</th>
					<th className='orgs-header'>Page URL</th>
					<th className='orgs-header'>Display Columns</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<select
							name='newOrgSel'
							onChange={this.handleChange}
						>
							<option value='' >[Select]</option>
							{ newOrgSelOptions }
						</select>
					</td>
					<td>
						<input
							type='text'
							name='newSiteName'
							minLength={5}
							maxLength={40}
							onChange={this.handleChange}
							value={this.state.newSiteName}
						/>
					</td>
					<td>
						<input
							type='text'
							name='newOrgUrl'
							minLength={5}
							maxLength={40}
							onChange={this.handleChange}
							value={this.state.newOrgUrl}
						/>
					</td>
					<td style={{textAlign: 'left'}}>{newOrgCols}</td>
				</tr>
			</tbody>
		</table>
		);

		// Make sure the user knows exactly how dangerous deleting publications is
		const deleteModal = (this.state.deleteModalVisible)
			? (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='orgs-modal'>
							<header>
								<span>Confirm</span>
								<button
									onClick={this.handleDeleteModalHide}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
								<div className='orgs-modal-content' style={{textAlign: 'center'}} >
									Are you sure? <br/>
									Deleting this Page and associated Columns will remove it from the pool and from the Organization!<br/>
									This action CANNOT be undone. The data CANNOT be retrieved.
								</div>
							<footer>
								<button
									onClick={this.deleteSite}
									type='button'
									aria-label='confirm'
								>
									Confirm
								</button>
								<button
									onClick={this.handleDeleteModalHide}
									type='button'
									aria-label='cancel'
								>
									Cancel
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			)
			: null;

		const newModal = (this.state.newModalVisible)
			? (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='orgs-modal'>
							<header>
								<span>Add Page</span>
								<button
									onClick={this.handleNewModalHide}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
							<div className='orgs-modal-content' style={{overflowX:'auto'}}>
								{addNewSite}
							</div>
							<footer>
								{
									this.state.ModalMessage
										? <div className='error-text' style={{textAlign: 'center'}}>{this.state.ModalMessage}</div>
										: null
								}
								<button
									onClick={this.createSite}
									type='button'
									aria-label='confirm'
								>
									Confirm
								</button>
								<button
									onClick={this.handleNewModalHide}
									type='button'
									aria-label='cancel'
								>
									Cancel
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			)
			: null;
			
		const editModal = this.state.editModalVisible 
			? (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='orgs-modal'>
							<header>
								<span>Edit Page</span>
								<button
									onClick={this.handleEditModalHide}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
							<div className='orgs-modal-content' style={{overflowX:'auto'}}>
								<table className='orgs-table'>
									<thead>
										<tr className='orgs-head-row'>
											<th className='orgs-header'>Organization</th>
											<th className='orgs-header'>Page Name</th>
											<th className='orgs-header'>Page URL</th>
											<th className='orgs-header'>Display Columns</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>
												{this.props.orgList.filter(org => org.id === this.state.siteToEdit.organizationId)[0].name}
											</td>
											<td>
												<input
													type='text'
													name='editSiteName'
													minLength={5}
													maxLength={40}
													onChange={this.handleChange}
													value={this.state.editSiteName}
												/>
											</td>
											<td>
												<input
													type='text'
													name='editOrgUrl'
													minLength={5}
													maxLength={40}
													onChange={this.handleChange}
													value={this.state.editOrgUrl}
												/>
											</td>
											<td style={{textAlign: 'left'}}>{
												this.state.colTypes.map((addCol) => {
													return (
														<div key={'editOrgCol-' + addCol} style={{ whiteSpace: 'nowrap', display: 'inline'}} >
															<input 
																type='checkbox'
																name='editOrgCols'
																id={addCol}
																checked={this.state.editSiteCols.includes(addCol)}
																onChange={this.handleEditOrgColsOptionChange}
																disabled={
																	['Author', 'Title', 'Publication/Event', 'Date', 'Type'].includes(addCol) // Required columns
																}
															/>
															<label htmlFor={addCol} style={{ paddingLeft: 5, wordWrap: 'anywhere' }}>{addCol}</label>
															<br />
														</div>
													);
												})
											}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<footer>
								{
									this.state.ModalMessage
										? <div className='error-text' style={{textAlign: 'center'}}>{this.state.ModalMessage}</div>
										: null
								}
								<button
									onClick={this.editSite}
									type='button'
									aria-label='confirm'
								>
									Confirm
								</button>
								<button
									onClick={this.handleEditModalHide}
									type='button'
									aria-label='cancel'
								>
									Cancel
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			)
			: null;

		const paginationContent = (
		<tr>
			<td
				onClick={this.prevPage}
				className={'clickable pagination-navigation-' + ((this.state.page >= 1) ? 'active' : 'inactive')}
			>
				Previous
			</td>
			<td colSpan={5} ></td>
			<td
				onClick={this.nextPage}
				className={'clickable pagination-navigation-' + ((this.state.page < (this.state.totalPages - 1)) ? 'active' : 'inactive')}
			>
				Next
			</td>
		</tr>
		);

		// Put it all together:
		return (
			<div>
				<h2>Organization Setup: View, Add, and Edit Organizations, Webpages, and Users</h2>
                <p>
                    <b
                        className='nav-button active'
                        style={{ borderColor: 'black' }}
                    >
						Organizations & Webpages
					</b>
                    <span style={{ paddingLeft: 15 }} />
                    <Link
                        to={{
                            pathname: '/users'
                        }}
                        className='nav-button'
                        style={{ borderColor: 'black' }}
                    >
                        Users
                    </Link>
                </p>
				<div>
				<table className='orgs-table'>
					<thead>
						<tr className='orgs-head-row'>
							<th className='orgs-header clickable' key='header-org' name='organization.name' onClick={this.sortChange} >
								Organization { }
								{this.state.sortCol === 'organization.name'
									? this.state.sortDir === 'asc'
										? <button
											className='icon-sort-up-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
										: <button
											className='icon-sort-down-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
									: <button
										className='icon-sort-up-and-down-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
								}
							</th>
							<th className='orgs-header clickable' key='header-site' name='name' onClick={this.sortChange} >
								Page Name { }
								{this.state.sortCol === 'name'
									? this.state.sortDir === 'asc'
										? <button
											className='icon-sort-up-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
										: <button
											className='icon-sort-down-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
									: <button
										className='icon-sort-up-and-down-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
								}
							</th>
							<th className='orgs-header clickable' key='header-url' name='url' onClick={this.sortChange} >
								Page URL { }
								{this.state.sortCol === 'url'
									? this.state.sortDir === 'asc'
										? <button
											className='icon-sort-up-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
										: <button
											className='icon-sort-down-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
									: <button
										className='icon-sort-up-and-down-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
								}
							</th>
							<th className='orgs-header clickable' key='header-sitekey' name='id' onClick={this.sortChange} >
							Key { }
							{this.state.sortCol === 'id'
								? this.state.sortDir === 'asc'
									? <button
										className='icon-sort-up-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
									: <button
										className='icon-sort-down-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
								: <button
									className='icon-sort-up-and-down-arrow ui-icon'
									style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
								/>
								}
							</th>
							<th className='orgs-header' key='header-cols' name='cols.columnName'  >
								Display Columns { }
							</th>
							<th className='orgs-header clickable' key='header-date' name='createdDate' onClick={this.sortChange} >
								Date Created { }
								{this.state.sortCol === 'createdDate'
									? this.state.sortDir === 'asc'
										? <button
											className='icon-sort-up-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
										: <button
											className='icon-sort-down-arrow ui-icon'
											style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
										/>
									: <button
										className='icon-sort-up-and-down-arrow ui-icon'
										style={{display: 'inline-block', border: 'none', backgroundColor: 'inherit', verticalAlign: 'inherit'}}
									/>
								}
							</th>

							<th className='orgs-header' key='header-actions' >
								Actions
							</th>
						</tr>
						<tr className='orgs-head-row'>
							<th className='orgs-header'>
                                <select
                                    name='organizationId'
                                    onChange={this.filterChange}
                                    value={this.state.filterArr['organizationId']}
                                >
                                    <option value='' >Select All</option>
                                    {
                                        this.state.userOrgList.sort((a, b) => {return a.name.localeCompare(b.name);}).map((org) => {
                                            return <option value={org.id} key={'orgid-' + org.id} >{
                                                org.name
                                            }</option>;
                                        })
                                    }
                                </select>

							</th>
							<th className='orgs-header'>
								<input
									type='text'
									name='name'
									maxLength={20}
									onChange={this.filterChange}
									value={this.state.filterArr['name'] || ''}

								/>
							</th>
							<th className='orgs-header'>
								<input
									type='text'
									name='url'
									maxLength={20}
									onChange={this.filterChange}
									value={this.state.filterArr['url'] || ''}

								/>
							</th>
                            <th className='orgs-header'>
                                <input
                                    type='number'
                                    name='id'
                                    maxLength={10}
                                    onChange={this.filterChange}
                                    value={this.state.filterArr['id'] || ''}

                                />
                            </th>

							<th className='orgs-header'>

							</th>

                            <th className='orgs-header'>
                                <input
                                    type='number'
                                    name='createdDate'
                                    min={0}
                                    max={9999}
                                    onChange={this.filterChange}
                                    value={this.state.filterArr['createdDate'] || ''}
                                    style={{ width: 45 }}
                                />
                            </th>
							<th className='master-pool-header'/>
						</tr>
					</thead>
					<tbody>
						{content}
					</tbody>
					<tfoot>

						{paginationContent}
					</tfoot>
				</table>
				</div>
				<div className='org-setup-button-container'>
					<div 
						className='org-setup-button clickable'
						onClick={this.handleNewModalShow}
					>
						Add Page
					</div>
				</div>
				{newModal}
				{editModal}
				{deleteModal}
			</div>
		);
	}
}

export default OrganizationSetup;